import { AuthState } from '../types';

const AUTH_TOKEN_KEY = 'authToken';
const AUTH_TIMESTAMP_KEY = 'authTimestamp';
const MAX_AUTH_AGE = 24 * 60 * 60 * 1000; // 24 hours

export const getStoredAuth = (): AuthState => {
  const token = sessionStorage.getItem(AUTH_TOKEN_KEY);
  const timestamp = sessionStorage.getItem(AUTH_TIMESTAMP_KEY);
  
  if (token && timestamp) {
    const tokenAge = Date.now() - parseInt(timestamp);
    
    if (tokenAge < MAX_AUTH_AGE) {
      return {
        isAuthenticated: true,
        token,
        timestamp
      };
    } else {
      clearAuth();
    }
  }
  
  return { isAuthenticated: false };
};

export const setAuth = (): void => {
  const sessionToken = btoa(`${Date.now()}-${Math.random()}`);
  const timestamp = Date.now().toString();
  
  sessionStorage.setItem(AUTH_TOKEN_KEY, sessionToken);
  sessionStorage.setItem(AUTH_TIMESTAMP_KEY, timestamp);
};

export const clearAuth = (): void => {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_TIMESTAMP_KEY);
};

export const validateCredentials = (username: string, password: string): boolean => {
  const validUsername = process.env.REACT_APP_ADMIN_USERNAME || 'admin';
  const validPassword = process.env.REACT_APP_ADMIN_PASSWORD;
  
  return username === validUsername && password === validPassword;
};

export const getAuthErrorMessage = (): string | null => {
  const validPassword = process.env.REACT_APP_ADMIN_PASSWORD;
  const validUsername = process.env.REACT_APP_ADMIN_USERNAME;
  
  if (!validPassword) {
    return 'Authentication not configured. Please set REACT_APP_ADMIN_PASSWORD.';
  }
  
  if (!validUsername) {
    return 'Username not configured. Please set REACT_APP_ADMIN_USERNAME.';
  }
  
  return null;
};